function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11",
  "data-name": "Ellipse 11",
  cx: 21,
  cy: 21,
  r: 21,
  fill: "#eeeff3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_244",
  "data-name": "Group 244",
  transform: "translate(11 11)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_220",
  "data-name": "Group 220",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(3.026)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M1196.174,6.944l-4.287-4.3a1.792,1.792,0,0,0-1.266-.518h-8.163a1.773,1.773,0,0,0-1.77,1.778l-.008,9.529a3.371,3.371,0,0,1,.839-.1,3.614,3.614,0,0,1,3.616,3.615,3.468,3.468,0,0,1-.206,1.2h9.994a1.791,1.791,0,0,0,1.778-1.786V8.195A1.748,1.748,0,0,0,1196.174,6.944Zm-11.047-1.267h2.136a.893.893,0,0,1,0,1.786h-2.136a.893.893,0,0,1,0-1.786Zm0,3.4h3.57a.893.893,0,0,1,0,1.785h-3.57a.893.893,0,0,1,0-1.785Zm5.371,5.356h-5.371a.889.889,0,0,1,0-1.778h5.371a.889.889,0,1,1,0,1.778Zm.862-6.081a.9.9,0,0,1-.892-.884V3.457l4.9,4.889Z",
  transform: "translate(-1180.68 -2.122)",
  fill: "#7d9ef1"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  d: "M1179.947,18.145a3.232,3.232,0,1,0,3.232,3.232A3.233,3.233,0,0,0,1179.947,18.145Zm1.963,2.594-.017.019h0l-1.89,2.068a.61.61,0,0,1-.863.023l-.023-.023L1178,21.591a.612.612,0,0,1,.024-.856.584.584,0,0,1,.826.009l.014.015.7.761,1.446-1.592a.583.583,0,0,1,.825-.038l.015.014A.592.592,0,0,1,1181.909,20.739Z",
  transform: "translate(-1176.714 -5.921)",
  fill: "#7d9ef1"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_119",
  "data-name": "Rectangle 119",
  width: 20,
  height: 20,
  fill: "none"
}));

var SvgRequiredDocumentsInsideCircle = function SvgRequiredDocumentsInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_254",
    "data-name": "Group 254",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequiredDocumentsInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/required-documents-inside-circle.45ef0457.svg";
export { ForwardRef as ReactComponent };